import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { sleep } from '@/utils/helpers';

import { createUserWithEmailAndPassword } from '@firebase/auth';
import {
    User,
    onAuthStateChanged,
    signInWithEmailAndPassword,
    signInWithPopup
} from 'firebase/auth';
import { GoogleAuthProvider } from 'firebase/auth';
import { firebaseAuth } from '@/firebase';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '@/configServices';
import { Registration } from '@/model/registration';
import { LocalDataServiceService } from './local-data-service';
import { AddCertificateDetails } from '@/model/certificateDetails/add-certificate-details';

const provider = new GoogleAuthProvider();

@Injectable({
    providedIn: 'root'
})
export class AppService {
    public user?: User | null = null;

    constructor(
        private router: Router,
        private toastr: ToastrService,
        private http: HttpClient, private configService: ConfigService,
        private localData: LocalDataServiceService
    ) {
        onAuthStateChanged(
            firebaseAuth,
            (user) => {
                if (user) {
                    this.user = user;
                } else {
                    this.user = undefined;
                }
            },
            (e) => {
                this.user = undefined;
            }
        );
    }

    async registerWithEmail(email: string, password: string) {
        try {
            const result = await createUserWithEmailAndPassword(
                firebaseAuth,
                email,
                password
            );
            this.user = result.user;
            this.router.navigate(['/']);
            return result;
        } catch (error) {
            this.toastr.error(error.message);
        }
    }

    async loginWithEmail(email: string, password: string) {
        try {
            const result = await signInWithEmailAndPassword(
                firebaseAuth,
                email,
                password
            );
            this.user = result.user;
            this.router.navigate(['/']);

            return result;
        } catch (error) {
            this.toastr.error(error.message);
        }
    }

    async signInByGoogle() {
        try {
            const result = await signInWithPopup(firebaseAuth, provider);
            this.user = result.user;
            this.router.navigate(['/']);

            return result;
        } catch (error) {
            this.toastr.error(error.message);
        }
    }

    // async getProfile() {
    //     try {
    //         await sleep(500);
    //         const user = firebaseAuth.currentUser;
    //         if (user) {
    //             this.user = user;
    //         } else {
    //             this.logout();
    //         }
    //     } catch (error) {
    //         this.logout();
    //         this.toastr.error(error.message);
    //     }
    // }

    async logout() {
        await firebaseAuth.signOut();
        this.user = null;
        this.router.navigate(['/login']);
    }

    //Login Api
    loginAuth(formData: any) {
        return this.http.post<any>(
            this.configService.getConfig().END_POINT + "/auth/login", formData
        )
    }

    //New user registration api
    registrationSave(formData: any) {
        return this.http.post<any>(
            this.configService.getConfig().END_POINT + "/auth/register", formData
        )
    }

    //Add Certificate details
    saveCertificateDetails(formData : FormData){
             return this.http.post<AddCertificateDetails>(
            this.configService.getConfig().END_POINT + "/api/certificate/save", formData,
            { headers: this.localData.getHeaders() }
        )   
    }

    //Get all certificate details
    getAllCertificateDetails(){
        return this.http.get<AddCertificateDetails[]>(
         this.configService.getConfig().END_POINT + "/api/certificate/get-all",
            { headers: this.localData.getHeaders() }   
        )
    }


    //Get id based certificate details
    getByCertificateIdDetails(id : string){
        return this.http.get<AddCertificateDetails>(
         this.configService.getConfig().END_POINT + "/api/certificate/get-certificate/" + id,
            { headers: this.localData.getHeaders() }   
        )
    }
}
